import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ReactNode } from 'react'
import { FaBars, FaTimes } from 'react-icons/fa'

interface DocsLayoutProps {
  children: React.ReactNode
  sidebarItems: {
    title: string
    path: string
    icon?: ReactNode
  }[]
}

const DocsLayout = ({ children, sidebarItems }: DocsLayoutProps) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true)
  const location = useLocation()

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* 侧边栏 */}
      <motion.div
        initial={{ x: -280 }}
        animate={{ x: isSidebarOpen ? 0 : -280 }}
        className="fixed left-0 top-0 h-full w-60 bg-white shadow-lg z-30 overflow-y-auto pt-16"
      >
        <div className="p-4">
          <h2 className="text-xl font-bold text-primary mb-4">目录</h2>
          <nav className="space-y-1">
            {sidebarItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center px-4 py-2 text-sm rounded-lg transition-colors ${
                  location.pathname === item.path
                    ? 'bg-primary text-white'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                {item.icon && <span className="mr-2">{item.icon}</span>}
                {item.title}
              </Link>
            ))}
          </nav>
        </div>
      </motion.div>

      {/* 主内容区 */}
      <div className={`flex-1 ${isSidebarOpen ? 'ml-60' : ''} transition-all duration-300`}>
        <div className="max-w-4xl mx-auto px-4 py-8">
          {children}
        </div>
      </div>

      {/* 切换侧边栏按钮 */}
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        className="fixed bottom-4 right-4 bg-primary text-white p-3 rounded-full shadow-lg z-40"
        aria-label={isSidebarOpen ? "关闭侧边栏" : "打开侧边栏"}
      >
        {isSidebarOpen ? <FaTimes /> : <FaBars />}
      </button>
    </div>
  )
}

export default DocsLayout 